// on-demand styling
// TODO: integrate small + popular codes with base CSS code
if (document.querySelector(".snippet.figure")) {
	loadCss("/assets/css/figure.css");
}
